export default function repeat<T>(times: number, create: (iteration: number) => T): T[] {
    const results: T[] = [];

    for (let iteration = 0; iteration < times; iteration++) {
        results.push(create(iteration));
    }

    return results;
}
